// @flow
import React, {Component} from 'react';
import {Provider} from 'react-redux';
import thunkMiddleware from 'redux-thunk';

import {createStore, applyMiddleware} from 'redux';

import reducers from '../reducers';
import AnalyticUtils from '../utils/AnalyticsUtil';

type Props = {
	environment: string,
	imsData?: Object,
	locale: string,
	routing?: boolean,
	children: Object
};

const createStoreWithMiddleware = applyMiddleware(thunkMiddleware)(createStore);
const STORE = createStoreWithMiddleware(reducers);

class AppsProvider extends Component<Props> {
	constructor(props: Props) {
		super(props);
		// set the enviornment
		window.ENV = this.props.environment;
		// TODO: find a better place to do this as it depends on window.ENV
		AnalyticUtils.setContext();
		if (!this.props.environment) {
			console.error(`CChome-Apps: props.environment is undefined (${this.props.environment})`);
		}
	}

	_getProvider() {
		const lang = this.props.locale || 'en';
		const locale = lang.substr(0, 2);
		// const localizedStrings = stringSets[lang];
		return (
			<Provider locale={locale} store={STORE}>
				{React.cloneElement(this.props.children, {...this.props})}
			</Provider>
		);
	}

	render() {
		const ResponseProvider = this._getProvider();
		return ResponseProvider;
	}
}


export default AppsProvider;
